module.exports = __webpack_public_path__ + "static/media/17_r_stena_0_0.54d589d4.png";